module.exports = __webpack_public_path__ + "static/media/partner-2.c2fc25e1.jpg";